import variables from '../variables';

const typograhpy = {
  fontFamily: variables.font.fontFamily.join(','),
  ...variables.typography,
  useNextVariants: true,
};

export default typograhpy;
